import { useLang } from '@/i18n';
import { useOnceInView } from '@elem/compPage/on-the-road-power-solution/pages/product/components/US/useOnceInView';
import { useEffect, useRef, useState } from 'react';
import css from './index.module.scss';
import Tab1 from './Tab1';
import Tab2 from './Tab2';

const H: React.FC = () => {
    const { t } = useLang('stream.overview');
    const [activeTab, setActiveTab] = useState(0);
    const [initedTabs, setInitedTabs] = useState([true, false]);
    const tabs: string[] = [t('H_tab1'), t('H_tab2')];

    const handleChangeTab = (e: any, idx: number) => {
        setActiveTab(idx);
        if (idx !== -1 && !initedTabs?.[idx]) {
            const newInited = JSON.parse(JSON.stringify(initedTabs));
            newInited[idx] = true;
            setInitedTabs(newInited);
        }
        if (window.innerWidth < 1024) {
            e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    };

    const indicatorRef = useRef<HTMLDivElement>(null);
    const tabsRef = useRef<HTMLUListElement>(null);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (!indicatorRef.current || !tabsRef.current) return;

        const activeEl = tabsRef.current.querySelector('.active') as HTMLDivElement;
        if (!activeEl) return;
        const { left: tabsLeft } = tabsRef.current.getBoundingClientRect();
        const { width, left } = activeEl.getBoundingClientRect();

        indicatorRef.current.style.transform = `translateX(${left - tabsLeft + tabsRef.current.scrollLeft}px)`;
        indicatorRef.current.style.width = `${width}px`;
    }, [activeTab]);

    useOnceInView('.stream-nl-H .title', () => {
        document.querySelector('.stream-nl-H .title')?.classList.add('enter');
        document.querySelector('.stream-nl-H .desc')?.classList.add('enter');
        document.querySelector('.stream-nl-H .content')?.classList.add('enter');
    });

    return (
        <div className={`${css.section} stream-nl-H GtmModuleData-section space white`} id="stream-nl-H" data-section-id={'stream-nl-H'}>
            <div className="info">
                <h2 className="title ani-1">{t('H_title')}</h2>
                <p className="desc ani-2">{t('H_desc')}</p>
            </div>
            <div className="content ani-3">
                <div className="box">
                    {initedTabs?.[0] && (
                        <div className={`box-tab${activeTab === 0 ? ' active' : ''}`}>
                            <Tab1 />
                        </div>
                    )}
                    {initedTabs?.[1] && (
                        <div className={`box-tab${activeTab === 1 ? ' active' : ''}`}>
                            <Tab2 />
                        </div>
                    )}
                </div>
                <ul className="tabs" ref={tabsRef}>
                    {tabs?.map((tab: string, i: number) => (
                        <li className={`tab tab-${i + 1}${activeTab === i ? ' active' : ''}`} key={tab} onClick={(e: any) => handleChangeTab(e, i)}>
                            {tab}
                        </li>
                    ))}
                    <div className="tab-indicator" ref={indicatorRef}></div>
                </ul>
            </div>
        </div>
    );
};

export default H;
